import { render, staticRenderFns } from "./Signataires.vue?vue&type=template&id=4a8cdac0&"
import script from "./Signataires.vue?vue&type=script&lang=js&"
export * from "./Signataires.vue?vue&type=script&lang=js&"
import style0 from "./Signataires.vue?vue&type=style&index=0&id=4a8cdac0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports